import type { ChangelogEntry } from "../types";

/**
 * VIB-2722. Eier og medredaktører på dokumenter. Gatet på
 * `feature_dokumentarkiv` som resten av arkivet.
 *
 * Ingen rollekrav: hvem som eier eller kan redigere styres per dokument, ikke
 * av systemrollen, så dette gjelder alle som har skrivetilgang et sted.
 */
export const EIERSKAP_2026_10: ChangelogEntry = {
  id: "2026-10-02-eierskap",
  date: "2026-10-02",
  title: "Dokumenter har en eier, og eieren kan slippe inn andre",
  summary:
    "Den som oppretter et dokument eier det, og kan gi enkeltpersoner rett til å redigere akkurat det, uten å gi dem tilgang til hele mappa.",
  sections: [
    {
      heading: "Dokumenter",
      items: [
        {
          title: "Du eier dokumentene du oppretter",
          kind: "nytt",
          body: "Som eier kan du redigere dokumentet ditt selv om du ikke har skrivetilgang til mappa det ligger i. Det betyr at den som faktisk er ansvarlig for en rutine kan vedlikeholde den, uten at alle admins må regnes som forfattere.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Gi en kollega redigeringstilgang til ett dokument",
          kind: "nytt",
          body: "Eieren kan slippe inn folk som allerede kan lese mappa. De kan da redigere og lagre, men ikke gi tilgangen videre til flere. Det er med vilje: ellers kunne én delt tilgang forgrene seg uten at eieren vet om det.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Dere kan ikke lenger overskrive hverandre i stillhet",
          kind: "nytt",
          body: "Har to personer samme dokument oppe, og begge lagrer, får den siste beskjed om at noen andre har lagret i mellomtiden. Teksten din blir stående i feltet, så ingenting går tapt, men du må kopiere den ut og laste siden på nytt før du lagrer.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
  ],
};
